import formula_functions from './formula_functions';

$(document).ready(function (e) {
    if ($('.create-update-fields').length) {
        let $dips = $('.data-input[data-type="formula"]');

        if ($dips.length) {
            $($dips).each(function (i, $dip) {
                let holders = $($dip).attr('data-holders');
                if (holders.length) {
                    holders = JSON.parse(holders);
                    let data = [];
                    $(holders).each(function (i, holder) {
                        $('.data-input[name="' + holder + '"]').off('keyup').on('keyup', function () {
                            formula_functions.executeFormulas();
                        });
                    });
                }
            });
        }

        $dips = $('.button-container').find('.data-input[data-type="formula"]');

        if ($dips.length) {
            $($dips).each(function (i, $dip) {
                let holders = $($dip).attr('data-holders');
                if (holders.length) {
                    holders = JSON.parse(holders);
                    let data = [];
                    $(holders).each(function (i, holder) {
                        $('.data-input[id="' + holder + '"]').off('keyup').on('keyup', function () {
                            let $container = $(this).parents('.button-container');
                            formula_functions.evaluateSectionPlaceholders($container)
                        });
                    });
                }
            });
        }
    }

    $(document).on('click', '.edit-formula-order', function (e) {
        e.preventDefault();

        let $modal = $('#formula-order-modal'),
            $body = $('#formula-order-body'),
            $title = $('#formula-order-title'),
            table_id = $('.builder-main').data('id');

        $.ajax({
            type: 'GET',
            url: '/tablebuilder/formula_builder/fields/order',
            data: {
                table_id
            },
            success: (res) => {
                $body.html(res);

                attachSortableHandler();
                $modal.modal('show');
            }
        })
    });

    function attachSortableHandler() {
        $(".formula-sort-container").sortable({
            items: "li",
            //cursor: 'grab',
            opacity: 0.6,
            forcePlaceholderSize: true,
            update: function () {

            }
        });
    }

    $('#save-formula-order').on('click', function (e) {
        e.preventDefault();
        let fields = [];
        let $modal = $('#formula-order-modal'),
            $body = $('#formula-order-body'),
            $title = $('#formula-order-title'),
            table_id = $('.builder-main').data('id');
        $('.formula-field').each(function (index, $field) {
            let id = $($field).attr('data-id');
            fields.push({
                id,
                order: index + 1,
            });
        });
        $.ajax({
            type: 'POST',
            url: '/tablebuilder/formula_builder/fields/order',
            data: {
                fields
            },
            success: function (res) {
                if (res) {
                    $modal.modal('hide');
                    $body.empty();
                    toastr.success('Formula order updated');
                }
            }
        })
    });
});

// function evaluateSectionPlaceholders($container) {
//     let $dips = $($container).find('.data-input[data-type="formula"]');
//     let payload = [];
//
//     if(tenant_name === 'altius'){
//         $dips = $($container).find('.data-input[data-type="formula"]').sort(function(a, b) {
//             return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
//         });
//     }
//
//     if ($dips.length) {
//         $($dips).each(function (i, $dip) {
//             let holders = JSON.parse($($dip).attr('data-holders')),
//                 id = $($dip).data('id'),
//                 action = $($dip).data('action'),
//                 table_id = '',
//                 record_id = '',
//                 data = {},
//                 relations = {},
//                 vat_zone = $('.hidden-relation[name="vat_zone"]').val();
//
//             if (action === 'edit') {
//                 table_id = $($dip).data('table-id');
//                 record_id = $($dip).data('record-id');
//             }
//
//             if (holders.length) {
//                 $(holders).each(function (i, holder) {
//                     data[holder] = $($container).find('.data-input[data-field="' + holder + '"]').val();
//
//                     if (!$($container).find('.data-input[data-field="' + holder + '"]').length) {
//
//                         let $relation_fields = $($container).find('.relation-data-field');
//
//                         $relation_fields.each(function (index, $relation_field) {
//                             let $parent = $($relation_field).parents('.editable-td');
//
//                             if ($parent.length) {
//                                 let mappings = $parent.attr('data-mappings');
//
//                                 if (mappings.length) {
//                                     mappings = JSON.parse(mappings);
//                                     mappings.forEach(function (mapping) {
//                                         if (mapping[0] === holder.toString()) {
//                                             let value = $parent.attr('data-value');
//                                             if (value.length) {
//                                                 relations[mapping[1]] = [value, mapping[0]];
//                                             }
//                                         }
//                                     });
//                                 }
//                             }
//                         })
//                     }
//                 });
//
//                 payload.push({
//                     id,
//                     data,
//                     action,
//                     table_id,
//                     record_id,
//                     relations,
//                     vat_zone
//                 });
//             }
//         });
//
//         if (payload.length) {
//             payload = JSON.stringify(payload);
//             $.ajax({
//                 type: 'GET',
//                 url: '/parse_formula/quick',
//                 data: {
//                     payload
//                 },
//                 success: function (data) {
//                     Object.keys(data).forEach(function (key) {
//                         if (data[key] !== 'invalid') {
//                             let $dip = $($container).find(`.data-input[data-type="formula"][data-id="${key}"]`);
//                             $($dip).val(data[key]);
//                             $($dip).closest('.form-group').addClass('control-highlight');
//                         }
//                     });
//                 }
//             })
//         }
//     }
// }